module.exports = __webpack_public_path__ + "img/abacus_type_2 (old).f492f986.png";